"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrift_discs = exports.getCrc_discs = void 0;
var crokinolePucks_sidecar_1 = require("@crokinole/entities/crokinolePucks-sidecar");
var crokinoleDefs_sidecar_1 = require("@crokinole/main/crokinoleDefs-sidecar");
var easyCrc_sidecar_1 = require("@dive/to-engine/easyCrc-sidecar");
var namespace = 'crokinole-crc-discs';
function getCrc_discs() {
    var e_1, _a;
    var _b = easyCrc_sidecar_1.easyCrc.create(namespace), add = _b.add, addVec2Round = _b.addVec2Round, getCrc = _b.getCrc;
    var doRound = crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs_round;
    var addRigidBody = function (c) {
        addVec2Round(c.translation(), doRound);
        // add(c.rotation())
        // addVec2(c.linvel())
        // add(c.angvel())
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs) {
            console.log(namespace, 't', c.translation());
            // console.log(namespace, 'r', c.rotation())
            // console.log(namespace, 'lv', c.linvel())
            // console.log(namespace, 'av', c.angvel())
        }
    };
    try {
        // TODO: sort by id?
        for (var _c = __values(crokinolePucks_sidecar_1.crokinolePucks.getAll()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var c = _d.value;
            if (c.isDead) {
                continue;
            }
            add(c.id);
            add(c.isOffBoard);
            add(c.isDiscarded);
            addRigidBody(c.rigidBody);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs) {
        console.log(namespace, 'getCrc', getCrc());
    }
    return getCrc();
}
exports.getCrc_discs = getCrc_discs;
function addVec2Round(arg0, doRound) {
    throw new Error('Function not implemented.');
}
function getDrift_discs() {
    var e_2, _a;
    var drift = 0;
    try {
        for (var _b = __values(crokinolePucks_sidecar_1.crokinolePucks.getAll()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var c = _c.value;
            if (c.isDead) {
                continue;
            }
            drift += c.rigidBody.translation().x;
            drift += c.rigidBody.translation().y;
            drift += c.rigidBody.rotation();
            drift += c.rigidBody.linvel().x;
            drift += c.rigidBody.linvel().y;
            drift += c.rigidBody.angvel();
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return drift;
}
exports.getDrift_discs = getDrift_discs;
